export default __webpack_public_path__ + "static/media/whiteLoader.f53aa23f.gif";